import { Link } from "gatsby"
import * as React from "react"
import { FaTimes } from "react-icons/fa"
import * as styles from "./sidebar.module.scss"

const Sidebar = ({ isOpen, toggle }) => {
  void React
  return (
    <aside
      className={styles.sidebar + " " + (isOpen ? styles.showSidebar : "")}
    >
      <div className="container">
        <button
          aria-label="close button"
          className={styles.closeBtn}
          onClick={toggle}
        >
          <FaTimes />
        </button>
        <div className={styles.linksContainer}>
          <ul>
            <li>
              <Link to="/" activeClassName="active">
                főoldal
              </Link>
            </li>
            <li>
              <Link to="/floorball" activeClassName="active">
                floorball
              </Link>
            </li>
            <li>
              <Link to="/tortenet" activeClassName="active">
                a tortenet
              </Link>
            </li>
            <li>
              <Link to="/csapat" activeClassName="active">
                a csapat
              </Link>
            </li>
            <li>
              <Link to="/kapcsolat" activeClassName="active">
                kapcsolat
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  )
}

export default Sidebar
